export type ICategoryType = number | null | 'uncategorized'

export enum SortingFilterValues {
  Activity = 'last_activity.desc',
  ActivityAsc = 'last_activity.asc',
  DatePublished = 'date_published.desc',
  DatePublishedAsc = 'date_published.asc',
  Relevance = 'relevance.desc', // TODO this does not exist in the backend
  Id = 'id.desc',
  IdAsc = 'id.asc',
  SolutionCount = 'solution_count.desc',
  SolutionCountAsc = 'solution_count.asc',
  ViewCount = 'view_count.desc',
  ViewCountAsc = 'view_count.asc',
  Interest = 'interest.desc',
  ActivityAndInterest = 'activity_and_interest.desc',
}

export interface IFilterValue {
  knowledgeSpaceId: number | null;
  categoryIds: ICategoryType[];
  filter: FilterValues[];
  topics: string[];
  includeArchived: boolean
}

export interface ISavedFilter extends IFilterValue {
  filterName: string;
}

export interface IDeeplinkFilterParams {
  questions_query?: string,
  query?: string;
  search?: string; // Legacy search parameter that we still support for compatibilty. It's an alias for "query".
  space?: string;
  categories?: string;
  filter?: string;
  sort?: SortingFilterValues;
  tags?: string;
  concepts?: string;
  include_archived?: string,
  include_deleted?: string,
  limit?: string,
  offset?: string
}

export interface IStreamEndpointParams {
  query?: string;
  knowledgeSpace?: number;
  categories?: string;
  include_uncategorized?: boolean;
  filter?: string;
  sort?: SortingFilterValues;
  tags?: string[];
  concepts?: string[];
  include_archived?: boolean
}

export enum FilterValues {
  All = 'all',
  Unsolved = 'unsolved',
  Solved = 'solved',
  Accepted = 'accepted',
  Verified = 'verified',
  Unverified = 'unverified',
  Expired = 'expired',
  MyQuestions = 'my-questions',
  MySolutions = 'my-solutions',
  Following = 'following',
  Trending = 'trending',
  Flagged = 'flagged'
}
